export default {
    'button.search': 'Search',
    'button.export': 'Export'
};
